import React, { useEffect, useState } from 'react';
import { Dimensions } from 'react-native';
import { type ScaledSize } from 'react-native/Libraries/Utilities/Dimensions';
import { Icon, View, XStack, YStack } from 'smoothie';

import { APP_HEADER_HEIGHT } from '../../../common/components/AppHeader';
import {
    PreviewSection,
    PreviewSectionIconMap,
} from '../../types/PreviewSection';

export const SIDEBAR_WIDTH = 80;

interface SectionToggleButtonProps {
    section: PreviewSection;
    isSelected: boolean;
    onPress: () => void;
}

const SectionToggleButton = ({
    section,
    isSelected,
    onPress,
}: SectionToggleButtonProps) => {
    return (
        <XStack
            alignItems="center"
            padding={8}
            onPress={() => {
                onPress();
            }}
            hoverStyle={{ cursor: 'pointer' }}
        >
            <View
                rotate={
                    section === PreviewSection.INCOME_SPLIT
                        ? '180deg'
                        : undefined
                }
            >
                <Icon
                    icon={PreviewSectionIconMap[section]}
                    color={isSelected ? '$green900' : '$black'}
                />
            </View>
        </XStack>
    );
};

interface SidebarProps {
    moneyMapToggle: boolean;
    onToggleMoneyMap: () => void;
    goalsToggle: boolean;
    onToggleGoals: () => void;
    accountsToggle: boolean;
    onToggleAccounts: () => void;
    incomeSplitToggle: boolean;
    onToggleIncomeSplit: () => void;
}

export const Sidebar = ({
    moneyMapToggle,
    onToggleMoneyMap,
    goalsToggle,
    onToggleGoals,
    accountsToggle,
    onToggleAccounts,
    incomeSplitToggle,
    onToggleIncomeSplit,
}: SidebarProps) => {
    const [screenHeight, setScreenHeight] = useState(
        Dimensions.get('window').height,
    );

    // Update the screenHeight on window resize events.
    useEffect(() => {
        const onChange = ({ window }) => {
            setScreenHeight((window as ScaledSize).height);
        };

        const subscription = Dimensions.addEventListener('change', onChange);

        return () => {
            subscription.remove();
        };
    }, []);

    const dynamicHeight = screenHeight - APP_HEADER_HEIGHT;

    return (
        <View position="fixed" left={0} height={dynamicHeight}>
            <YStack
                flex={1}
                width={80}
                padding={16}
                marginTop={16}
                $sm={{ marginTop: 0 }}
                backgroundColor="$white"
                borderRightWidth={1}
                borderRightColor="$gray500"
            >
                <YStack alignItems="center" gap={16} marginTop={8}>
                    <SectionToggleButton
                        section={PreviewSection.MONEY_MAP}
                        isSelected={moneyMapToggle}
                        onPress={onToggleMoneyMap}
                    />
                    <SectionToggleButton
                        section={PreviewSection.GOALS}
                        isSelected={goalsToggle}
                        onPress={onToggleGoals}
                    />
                    <SectionToggleButton
                        section={PreviewSection.ACCOUNTS}
                        isSelected={accountsToggle}
                        onPress={onToggleAccounts}
                    />
                    <SectionToggleButton
                        section={PreviewSection.INCOME_SPLIT}
                        isSelected={incomeSplitToggle}
                        onPress={onToggleIncomeSplit}
                    />
                </YStack>
            </YStack>
        </View>
    );
};
